import { render, staticRenderFns } from "./listarAnuncios.vue?vue&type=template&id=61179f6a"
import script from "./listarAnuncios.vue?vue&type=script&lang=js"
export * from "./listarAnuncios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports